export const FETCH_REQUESTED = "display_home_for_sale/FETCH_REQUESTED"
export const FETCH_SUCCESS = "display_home_for_sale/FETCH_SUCCESS"
export const FETCH_FAILED = "display_home_for_sale/FETCH_FAILED"

export const FILTER_UPDATE_NO_FETCH = "display_home_for_sale/FILTER_UPDATE_NO_FETCH"
export const OBJECT_SORTED = "display_home_for_sale/OBJECT_SORTED"
